import React, { useState, useEffect } from "react";
import firebase from "@firebase/app";
import "@firebase/auth";
import ProductsTable from "../components/Products/ProductsTable";
import { getProducts, addBoxes } from "../services/ProductService";
import "react-datepicker/dist/react-datepicker.css";
import {Container,Col,Row,Button} from "react-bootstrap";
import { Input } from "reactstrap";
import {ConfirmStockModal} from "../components/Modals/ConfirmStockModal";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../assets/css/table.css"

function ProductsListView() {
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: '',
    new:false 
  });


  const handleShowConfirmModal = () => {
      var list = products.filter(p => p.checked && p.boxQuantity > 0)
      if (list && list.length > 0)
        setShowConfirmModal(true)
  };

  function onChange(user) {
    if (!user) {
      window.location.href = "/";
    }
    setLoading(false);
  }

  React.useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  useEffect(async () => {
    if (!loading) {
      setProductsLoading(true);
      const products = await getProducts();
      if (!products) {
        alert("Une erreur s'est produite");
        return;
      }
      products.forEach(p => p.boxQuantity = 1);
      setProducts(products);
      setProductsLoading(false);
    }
  }, [loading]);

  if (loading || productsLoading) {
    return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }
  if (!products) {
    console.log("No products");
    return null;
  }

  const handleSearchFilter = (filterType, value) => {
    let newFilter = {
      ...filters,
      [filterType]: value,
    };
    setFilters(newFilter);
  };

  const submitSearch = (name) => {
      let filteredProducts = [...products];
      filteredProducts.forEach(product => {
        if (name.trim().length > 0) {
          product.hide = !product.name.toLowerCase().includes(name)
        } else {
          product.hide = false;
        }
      });
      setProducts(filteredProducts);

  };

  const handleCloseConfirmModal = () => setShowConfirmModal(false);

  const handleStockConfrimClick = () => {
    setShowConfirmModal(false);
      addBoxes(products);
  }

  return (
    <Container fluid>
      <ConfirmStockModal
        show={showConfirmModal}
        handleClose={handleCloseConfirmModal}
        handleClick={handleStockConfrimClick}
        products={products}
      ></ConfirmStockModal>
        <Row md="10" style={{ alignItems: "flex-end" }}>
          <Col md="6">
            <label htmlFor="name">Name</label>
            <Input value={filters.name} onChange={(e) => {
              handleSearchFilter('name', e.target.value)
              submitSearch(e.target.value.toLowerCase());
            }}/>
          </Col>
          <Col md="2">
            <Button
                style={{float:'right'}}
                onClick={() => {
                  handleShowConfirmModal()
                }}
                variant="primary" >Add Boxes</Button>
          </Col>
        </Row>
        <ProductsTable
          products={products}
          count={products.length}
          setProducts={setProducts}
        />
    </Container>
  );
}

export default ProductsListView;
